import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from 'utils/request';
import { SEQUENCES_CUSTOM_FIELDS_KEY } from './useSequenceCustomFieldDefinitions';

function reorderSequenceCustomFieldDefinitions(ids: string[]) {
  return request('/sequences-custom-fields/reorder', {
    method: 'PATCH',
    body: { ids },
  });
}

export const useReorderSequenceCustomFieldDefinitions = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: reorderSequenceCustomFieldDefinitions,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_CUSTOM_FIELDS_KEY],
      });
    },
  });
};
